export function delHtmlTag(str)
{
    const s = str.replace(/<style>[\s\S]*?<\/style>/gi, '').replace(/&nbsp;/g, '');//去掉所有样式标签
    return s.replace(/<[^>]+>/g,"");//去掉所有的html标记
}